import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { SimpleTableBase } from '../Table';

const ImportErrorTable = ({ errors = [] }) => {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(15);

  let errosFormatados =
    errors?.length > 0 &&
    errors?.map((error, index) => {
      return {
        id: index,
        linha: `Linha ${error?.linha}`,
        mensagemErro: error?.mensagemErro,
      };
    });

  const filtrarPagina = (paginaAtual, tamanhoPagina, errors) => {
    const inicio = paginaAtual * tamanhoPagina;
    const fim = Math.min(inicio + tamanhoPagina, errors?.length);
    return errors?.length > 0 ? errors?.slice(inicio, fim) : [];
  };

  const errorsPaginados = filtrarPagina(page, size, errosFormatados);

  const columns = [
    {
      title: 'Linha',
      name: 'linha',
      width: 150,
      getCellValue: (data) => data.linha,
    },
    {
      title: 'Mensagem',
      name: 'mensagemErro',
      getCellValue: (data) => data.mensagemErro,
    },
  ];

  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <SimpleTableBase
        hideSelection
        pageType="async"
        columns={columns}
        rows={errorsPaginados}
        totalCount={errors?.length}
        searchBy=""
        onCurrentPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(params) => {
          setSize(params);
        }}
      />
    </Grid>
  );
};

export default ImportErrorTable;
